import { ArrowRight } from 'lucide-react'
import { hero } from '../data/site'
import HeroIllustration from './illustrations/HeroIllustration'

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-32 pb-20 sm:pt-36 lg:pt-40">
      {/* soft gradient backdrop */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-brand-50 via-white to-white" />
        <div className="absolute -top-24 right-0 h-96 w-96 rounded-full bg-brand-200/40 blur-3xl" />
        <div className="absolute top-40 -left-24 h-80 w-80 rounded-full bg-sky-200/40 blur-3xl" />
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-12 px-6 lg:grid-cols-2">
        {/* copy */}
        <div className="reveal is-visible">
          <span className="inline-flex items-center gap-2 rounded-full border border-brand-100 bg-white px-4 py-1.5 text-sm font-medium text-brand-700 shadow-sm">
            <span className="h-2 w-2 rounded-full bg-brand-500" />
            {hero.eyebrow}
          </span>

          <h1 className="mt-6 text-[clamp(2.5rem,5.5vw,4rem)] font-bold leading-[1.05] tracking-tight text-slate-900">
            {hero.title}
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-slate-500">
            {hero.subtitle}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href={hero.primaryCta.href}
              className="group inline-flex items-center gap-2 rounded-full bg-brand-600 px-6 py-3.5 text-sm font-semibold text-white shadow-[var(--shadow-lift)] transition-all hover:bg-brand-700 hover:-translate-y-0.5"
            >
              {hero.primaryCta.label}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href={hero.secondaryCta.href}
              className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-6 py-3.5 text-sm font-semibold text-slate-700 transition-all hover:border-brand-200 hover:text-brand-700"
            >
              {hero.secondaryCta.label}
            </a>
          </div>
        </div>

        {/* illustration */}
        <div className="relative">
          <HeroIllustration className="mx-auto w-full max-w-lg" />
        </div>
      </div>
    </section>
  )
}
